import React from "react";

import "./styles.scss"
import ChatInsightsMain from "../../esg-chat/insights";

const CustomInsights = () => {
    return (
        <ChatInsightsMain model="Custom" />
    )
}

export default CustomInsights